module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/battle-payments-elite.30ba5e40.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/battle-payments-elite.png
// module id = 3735
// module chunks = 11